import Utilitiesjs from './utilites';
import Ajaxjs from './ajax';
import Dashboardjs from './controllers/dashboard';
import DashboardTabindexjs from './controllers/dashboardTabindex'
import Accountjs from './controllers/account';
import Profilejs from './controllers/profile';
import Guarantorjs from './controllers/guarantor';
import DeclarationOfCasesjs from './controllers/declarationOfCases';
import ContactFormjs from './controllers/contactForm';
import CreatePasswordFormjs from './controllers/createPasswordForm';
import NominationFormjs from './controllers/nominationForm';
import JobPostingFormjs from './controllers/jobPostingForm';
import MemberExtensionApplicationFormjs from './controllers/memberExtensionApplicationForm';
import Calendarjs from './controllers/calendar';
import CertifyingExamApplicationjs from './controllers/certifyingExamApplication';

import CertifiedMembersList from './controllers/certifiedMembersList';
import MemberApplicationjs from './controllers/memberApplication';
import ExpenseFormjs from './controllers/expenseForm';
import InternationalApplicantsFormjs from './controllers/internationalApplicantsForm';
import SubmitAnAbstractFormjs from './controllers/submitAnAbstractForm';

import Tablesjs from './tables';
import JobPostingReportjs from './Controllers/jobpostingReport';
import MembersReportjs from './Controllers/membersReport';
import EventsReportjs from './Controllers/eventsReport';
import AdminPagejs from './Controllers/adminPage';
import BingSiteSearchjs from './Controllers/bingSiteSearch';
import Modulesjs from './Controllers/Modules';
import AbstractReportjs from './Controllers/abstractReport';
import CertifyExamReportjs from './Controllers/certifyExamReport';
import InternationalApplicantsReportjs from './Controllers/internationalApplicantsReport';
import EventListReportjs from './Controllers/eventListReport';
import ExpenseReportjs from './Controllers/expenseReport';
import MemberOrdersJs from './Controllers/memberOrders';

//Ecomm related modules
import ArbitraryAmountFormJs from "./controllers/arbitraryAmountForm";
import MemberDuesFormJs from "./controllers/memberdues";
import EventPaymentFormJs from "./controllers/eventPaymentForm";
import ApplyForAssociateFormJs from "./controllers/applyForAssociate";

//Apply overrides:
import ECommOverrides from "./ecommOverrides";
ECommOverrides.applyOverrides();

export default {
    dashboardjs: new Dashboardjs,
    dashboardTabindexjs : new DashboardTabindexjs,
    utilsjs: new Utilitiesjs,
    accountjs: new Accountjs,
    profilejs: new Profilejs,
    guarantorjs: new Guarantorjs,
    declarationOfCasesjs: new DeclarationOfCasesjs,
    contactFormjs: new ContactFormjs,
    jobPostingFormjs: new JobPostingFormjs,
    createPasswordFormjs: new CreatePasswordFormjs,
    memberExtensionApplicationFormjs: new MemberExtensionApplicationFormjs,
    nominationFormjs: new NominationFormjs,
    ajaxjs: new Ajaxjs,
    calendarjs: new Calendarjs,
    certifyjs: new CertifyingExamApplicationjs,
    tablesjs: new Tablesjs,
    memberApplicationjs: new MemberApplicationjs,
    certifiedMembersList: new CertifiedMembersList,
    submitAnAbstractFormjs: new SubmitAnAbstractFormjs,
    internationalApplicantsFormjs: new InternationalApplicantsFormjs,
    expenseFormjs: new ExpenseFormjs,

    membersReportjs: new MembersReportjs,
    bingSiteSearchjs: new BingSiteSearchjs,
    eventsReportjs: new EventsReportjs,

    adminPagejs: new AdminPagejs,

    modulesjs: new Modulesjs,

    abstractReportjs: new AbstractReportjs,
    jobpostingReportJs: new JobPostingReportjs,
    certifyExamReportjs: new CertifyExamReportjs,
    internationalApplicantsReportjs: new InternationalApplicantsReportjs,
    eventListReportjs: new EventListReportjs,
    expenseReportjs: new ExpenseReportjs,

    //EComm related modules:
    arbitraryAmountFormJs: new ArbitraryAmountFormJs,
    memberDuesFormJs: new MemberDuesFormJs,
    eventPaymentFormJs: new EventPaymentFormJs,
    applyForAssociateFormJs: new ApplyForAssociateFormJs,
    MemberOrdersJs: new MemberOrdersJs
};






// WEBPACK FOOTER //
// ./Scripts/es6/main.js